import React, {useState} from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import homehero from "../assets/Images/homehero.png";
import Title from "../Co Components/Titles";
import PrimaryButton from "../Co Components/PrimaryButton";
import SecondaryButton from "../Co Components/SecondaryButton";
import HomeCard from "../Co Components/HomeCards";
import HomeCards from "../Co Components/HomeCards";
import LineButton from "../Co Components/LineButton";
import logofoot from '../assets/Images/logo-foot.png';
import arrow from '../assets/Images/Arrow.png';
import BlogCard from "../Co Components/BlogCards";
import { useEffect } from 'react';
import axios from "axios";
import PopupMessage from "../Co Components/PopupMessage";
import PopupCloseMessage from "../Co Components/PopupCloseMessage";

const Blog = () => {

    useEffect(() => {
        window.scrollTo(0, 0)


    });
         const [showPopup, setShowPopup] = useState(false);
    const [success,setSucess]=useState(false);
    const [error,setError]=useState(false);
    const handleButtonClick = () => {
        setShowPopup(true);
    };

    const handleCloseClick = () => {
        setShowPopup(false);
    };

    const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    axios.post('/contactus/email/', data,).then((response) => {
     if (response.status === 200) {
         // console.log('successful');
         setTimeout(() => {
        setSucess(true);
        event.target.reset();
        setShowPopup(true);
      }, 500);
         // console.log(response.data);
         // Redirect to the home page after login
      } else {
         // setError(true);
         setShowPopup(true);
         // console.log('failed');
     }
    });
  };
    return (
        <>

            <Nav />
            <section className={' d-flex flex-col flex-wrap mt-10  justify-content-lg-center'}>
                <article className={''}>
                    <div className={''}>
                        <center> <h1 className={'text-black bebas display-1 line-normal'}>
                            WHITEGUARD<span className={'bebas green display-1'}> case studies</span>
                            <br />SECURITY notice
                        </h1>
                            <img src={arrow} />
                            <p className={'fs-6 Poppins  w-75'}>
                                Be the first to know with exclusive access to our
                                cybersecurity spotlights newsletter!
                            </p>
                            <form className='contact-form w-75' onSubmit={handleSubmit}>
                                <input name={'email'} className='footinput w-100' placeholder='EMAIL ADDRESS' type={'email'} />
                                <button  className='secondary arrow '>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="23" viewBox="0 0 31 23" fill="none">
                                        <path d="M2.48633 9.9375C1.6579 9.9375 0.986328 10.6091 0.986328 11.4375C0.986328 12.2659 1.6579 12.9375 2.48633 12.9375V9.9375ZM30.0552 12.4982C30.641 11.9124 30.641 10.9626 30.0552 10.3768L20.5093 0.830898C19.9235 0.245111 18.9737 0.245111 18.3879 0.830898C17.8022 1.41669 17.8022 2.36643 18.3879 2.95222L26.8732 11.4375L18.3879 19.9228C17.8022 20.5086 17.8022 21.4583 18.3879 22.0441C18.9737 22.6299 19.9235 22.6299 20.5093 22.0441L30.0552 12.4982ZM2.48633 12.9375H28.9945V9.9375H2.48633V12.9375Z" fill="black" />
                                    </svg>
                                </button>
                            </form>
                        </center>
                    </div>
                </article>
            </section>
            <Title className={'mt-12'} header={"the"} body={"Blog"} />
            <div className={'d-flex flex-row  flex-wrap justify-content-center blog-container'}>
                <div className={'d-flex flex-column flex-wrap mt-5 justify-content-center'}>
                    <BlogCard
                        className={'danger  mx-4 mt-5  blog-card-blog'}
                        Title={'Egyptian Industry Under Siege: Unmasking the APT Assault'}
                        text={'A Big Industrial company in Egypt was compromised by APT.'}
                    />


                    <BlogCard
                        className={' success   mx-4 mt-5  blog-card-blog'}
                        Title={"Germany's GDPR Criticality: Company under risk from Access Control \Vulnerabilities"}
                        text={'A prominent telecom company in Germany was affected by broken access control vulnerabilities that affected their GDBR compliance.'}
                    />
                </div>

                <div className={'d-flex flex-column mt-5 flex-wrap justify-content-center'}>
                    <BlogCard
                        className={' success   mx-4 mt-5  blog-card-blog'}
                        Title={"Vineyard Vulnerabilities!!: A Wine Company's Account Takeover Saga"}
                        text={'A big Wine company in Europe was compromised by a zero-click account takeover.'}
                    />

                    <BlogCard
                        className={'info  mx-4 mt-5  blog-card-blog'}
                        Title={"Brazil's Online Job Classified maybe a fish hook"}
                        text={'A big online job classified company in Brazil compromised with critical vulnerabilities.'}
                    />
                </div>
                <div className={'d-flex flex-column mt-5 flex-wrap justify-content-center'}>
                    <BlogCard
                        className={'info  mx-4 mt-5 blog-card-blog'}
                        Title={'Data Breach Chronicles: an African Government Dilemma'}
                        text={'A prominent government entity in Africa grappled with significant data breaches.'}

                    />
                    <BlogCard
                        className={'danger  mx-4 mt-5  blog-card-blog'}
                        Title={'Security Misconfigurations Unveiled: Compromising big Companies in USA'}
                        text={'How Security misconfiguration could lead to compromise a big company in USA.'}
                    />

                </div>
            </div>
            {(showPopup && success) && (
                    <PopupMessage onClose={handleCloseClick} text={"Your message has been sent successfully!"} />
      )}
                {(showPopup && !success) &&
                    <PopupCloseMessage onClose={handleCloseClick} text={"Invalid data entry!"} />
      }
            <Footer />
        </>
    );

}

export default Blog;